import React, { Component } from "react";
import ReportTablePivot from "../ReportTablePivot";
import ReportTableDashboards from "../ReportTableDashboard";
import styles from "./../reportTable.module.scss";
import { v4 as uuidv4 } from "uuid";

const rowStyles = [styles.reportTableRowItemBackground, styles.reportTableRowItem];

class ReportTableDayContent extends Component {
  getRowCell(item, rowStyle) {
    return (
      <div key={uuidv4()} className={rowStyle} style={{ width: item.width + "px", border: "none" }}>
        <span style={{ border: "none" }}>{item.value}</span>
      </div>
    );
  }

  getRows(day) {
    let rowStyle = rowStyles[1];

    return day.rows.map((row) => {
      rowStyle = rowStyle === rowStyles[0] ? rowStyles[1] : rowStyles[0];

      return (
        <div className={styles.reportTableRowCursor} key={uuidv4()}>
          {row.data.map((item) => {
            return this.getRowCell(item, rowStyle);
          })}
        </div>
      );
    });
  }

  render() {
    const { day } = this.props;

    return (
      <div key={uuidv4()} className={styles.reportTableDashbordandRowsContainer}>
        {this.getRows(day)}
        <ReportTablePivot pivot={day.pivot} />
        <ReportTableDashboards dashboards={day.dashboard} />
      </div>
    );
  }
}

export default ReportTableDayContent;
